import React, { useState, useEffect} from 'react';

// material-ui
import { Grid, Stack, FormControl, ToggleButton, ToggleButtonGroup, Typography, OutlinedInput, InputAdornment, Button, FormControlLabel, Checkbox } from '@mui/material';
import { ArrowForward, Email, Search, Send, Print, Person3 } from '@mui/icons-material';

import { NoticeTypeEnums } from '../dataObjects/NoticeTypeEnums';
import AlertInfo from '../../../dataObjects/AlertInfo';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
interface Props {
    updateFineStatus: (status: string) => void;
    updateSearchInput: (input: string) => void;
    updatePayload: () => void;
    pendingNoticeCounts: any;
    issuesCount: number;
}

const FilerFilter = (props: Props): JSX.Element => {

    const [filerType, setFilerType] = useState('all');
    const [fineStatus, setFineStatus] = useState('active');
    const [fineNoticeType, setNoticeType] = useState(NoticeTypeEnums.Second);
    const [pendingNoticeCounts, setPendingNoticeCounts] = useState<any>({});

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    useEffect(() => {
        setPendingNoticeCounts(props.pendingNoticeCounts);
    }, [props.pendingNoticeCounts]);

    const getPendingPaperPdfs = (typeId: number) => {
        let pdfsUrl = `/FineTracker/GetPdfNotices?fineNoticeType=${typeId}`;
        window.open(pdfsUrl, "_blank");
    }

    const confirmSendingEmails = (noticeTypeId: number) => {
        setNoticeType(noticeTypeId);
        let info = {
            type: 'confirm',
            title: 'Confirm: Sending All Pending Emails',
            buttonLabel: "SEND",
            errorMessage: 'Are you sure you would like to send all the pending 2nd fine notices via emails?',
            secondaryErrorMessage: ''
        };
        setAlertInfo(info);
        setAlertInfoDialog(true);
    } 

    const emailNotices = (confirm: boolean) => {

        if (confirm) {
            let url = `/FineTracker/EmailNotices?fineNoticeType=${fineNoticeType}`
            fetch(url)
                .then(result => result.json())
                .then(result => {
                    let errorArray = result;
                    let firstError = errorArray.find((error: { isError: boolean; }) => error.isError === true);
                    if (firstError) {
                        let info = {
                            type: 'error',
                            title: 'Error: EmailNotices',
                            errorMessage: firstError.errorMessage,
                            secondaryErrorMessage: firstError.secondaryErrorMessage
                        };
                        setAlertInfo(info);
                        setAlertInfoDialog(true);
                    }
                    else {
                        let info = {
                            type: 'success',
                            title: 'Emails sent',
                            errorMessage: 'The fine notices emails were successfully sent',
                            secondaryErrorMessage: ''
                        };
                        setAlertInfo(info);
                        setAlertInfoDialog(true);

                        //refresh payload
                        props.updatePayload();;
                    }
                })
        }
        else {
            setAlertInfoDialog(false);
        }
    }

    const switchFineStatus = (event: any, newStatus: string) => {
        if (newStatus !== null) {
            setFineStatus(newStatus);
        }
        props.updateFineStatus(newStatus);
    };

    const updateSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTimeout(() => {
            if (event.target.value.length === 0) {
                setFineStatus('active');
                props.updateFineStatus('active');
            }
            else {
                setFineStatus('all');
                props.updateFineStatus('all');
            }
            
            props.updateSearchInput(event.target.value);
        }, 1000)
    }

    const markAllPaperNoticesSent = (typeId: number) => {

        fetch(`/fineTracker/MarkAllPendingPaperNoticesAsSent?fineNoticeType=${typeId}`)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: MarkAllPendingPaperNoticesAsSent',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    //props.updatePayload();
                    window.location.reload(); // reload the page to refresh the data
                }
            }
        )
    }

    return (
        <Grid container marginTop={5} display={'flex'} justifyContent="center">
            {/* search */}
            <Grid item xs={10} display="flex" justifyContent="flex-start" marginBottom={3}>
                <FormControl sx={{ minWidth: 200 }} variant="outlined" size="small">
                    <OutlinedInput
                        aria-label='search by filer name'
                        title='search by filer name'
                        placeholder={"Search filer..."}
                        onChange={updateSearchInput}
                        startAdornment={
                            <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    />
                </FormControl>
            </Grid>
            {/* fine status */}
            <Grid item xs={6}>
                <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                    <Person3 color="info" />
                    <Typography variant="subtitle1" fontWeight={550} width={150}>
                        Filer Type:
                    </Typography>
                    <ToggleButtonGroup
                        color="primary"
                        fullWidth={true}
                        size="small"
                        value={filerType}
                        exclusive
                        aria-label="Filer Types"
                        sx={{width: 450 }}
                    >
                        <ToggleButton value="all" sx={{ fontWeight: 800}}>All</ToggleButton>
                        <ToggleButton value="legacy" sx={{ fontWeight: 800 }}>Legacy / PACs</ToggleButton>
                        <ToggleButton value="legislative" sx={{ fontWeight: 800 }}>Legislative</ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Grid>
            <Grid item xs={4}>
                <Stack direction="row" spacing={1} alignItems="center" display="flex" justifyContent="flex-start">
                    <Typography variant="subtitle1" fontWeight={550}>
                        Status
                    </Typography>
                    <ToggleButtonGroup
                        color="primary"
                        value={fineStatus}
                        fullWidth={true}
                        size="small"
                        exclusive
                        aria-label="Fine Status"
                        sx={{ width: 300 }}
                        onChange={switchFineStatus}
                    >
                        <ToggleButton value="active" sx={{ fontWeight: 800 }}>
                            Active {fineStatus === "active" && `(${props.issuesCount})` } 
                        </ToggleButton>
                        <ToggleButton value="all" sx={{ fontWeight: 800 }}>
                            All {fineStatus === "all" && `(${props.issuesCount})`} 
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Grid>
            {/* email actions */}
            <Grid item xs={10} display="flex" justifyContent="flex-start" marginTop={3}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Email color="info" />
                    <Typography variant="subtitle1" fontWeight={550} width={150}>
                        Send Emails:
                    </Typography>
                    <Button onClick={() => confirmSendingEmails(NoticeTypeEnums.Second)} variant="outlined" color="error" endIcon={<Send />} disabled={pendingNoticeCounts.electronicSecondCount === 0} >
                        2nd Notices{`(${pendingNoticeCounts.electronicSecondCount})`}
                    </Button>
                    <Button onClick={() => confirmSendingEmails(NoticeTypeEnums.ThirtyDay)} variant="outlined" endIcon={<Send />} disabled={pendingNoticeCounts.electronic30DayCount === 0}>
                        30 days fine notices{`(${pendingNoticeCounts.electronic30DayCount})`}
                    </Button>
                    <Button onClick={() => confirmSendingEmails(NoticeTypeEnums.SixtyDay)} variant="outlined" endIcon={<Send />} disabled={pendingNoticeCounts.electronic60DayCount === 0}>
                        60 days fine notices{`(${pendingNoticeCounts.electronic60DayCount})`}
                    </Button>
                    <Button onClick={() => confirmSendingEmails(NoticeTypeEnums.NinetyDay)} variant="outlined" endIcon={<Send />} disabled={pendingNoticeCounts.electronic90DayCount === 0}>
                        90 days fine notices{`(${pendingNoticeCounts.electronic90DayCount})`}
                    </Button>
                    <Button onClick={() => confirmSendingEmails(NoticeTypeEnums.Final)} variant="outlined" endIcon={<Send />} disabled={pendingNoticeCounts.electronic120DayCount === 0}>
                        Final fine notices{`(${pendingNoticeCounts.electronic120DayCount})`}
                    </Button>
                </Stack>
            </Grid>
            {/* mail actions */}
            <Grid item xs={10} display="flex" justifyContent="flex-start" marginTop={3}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Print color="info" />
                    <Typography variant="subtitle1" fontWeight={550} width={150}>
                        Batch Print:
                    </Typography>
                    <Stack spacing={1} >
                        <Stack direction="row" spacing={1}>
                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.Initial)} variant="outlined" color="error" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paperInitialCount === 0}>
                                1st mails{`(${pendingNoticeCounts.paperInitialCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.Initial)} disabled={pendingNoticeCounts.paperInitialCount === 0} />} label="all mailed?" />
                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.Second)} variant="outlined" color="error" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paperSecondCount === 0}>
                                2nd mails{`(${pendingNoticeCounts.paperSecondCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.Second)} disabled={pendingNoticeCounts.paperSecondCount === 0} />} label="all mailed?" />         
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.ThirtyDay)} variant="outlined" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paper30DayCount === 0} >
                                30 days mails{`(${pendingNoticeCounts.paper30DayCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.ThirtyDay)} disabled={pendingNoticeCounts.paper30DayCount === 0} />} label="all mailed?" />

                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.SixtyDay)} variant="outlined" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paper60DayCount === 0} >
                                60 days mails{`(${pendingNoticeCounts.paper60DayCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.SixtyDay)} disabled={pendingNoticeCounts.paper60DayCount === 0} />} label="all mailed?" />

                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.NinetyDay)} variant="outlined" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paper90DayCount === 0}>
                                90 days mails{`(${pendingNoticeCounts.paper90DayCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.NinetyDay)} disabled={pendingNoticeCounts.paper90DayCount === 0} />} label="all mailed?" />

                            <Button onClick={() => getPendingPaperPdfs(NoticeTypeEnums.Final)} variant="outlined" endIcon={<ArrowForward />} disabled={pendingNoticeCounts.paper120DayCount === 0}>
                                Final mails{`(${pendingNoticeCounts.paper120DayCount})`}
                            </Button>
                            <FormControlLabel control={<Checkbox onClick={() => markAllPaperNoticesSent(NoticeTypeEnums.Final)} disabled={pendingNoticeCounts.paper120DayCount === 0} />} label="all mailed?" />
                        </Stack>
                    </Stack>
                </Stack>
            </Grid>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog} confirmAction={emailNotices}></AlertInfoDialog>
            }
        </Grid>   
    );
};

export default FilerFilter;